import { Link } from "react-router";
import { ChevronRight, Scale } from "lucide-react";
import { LEGAL_POLICY_ORDER } from "../data/legalPolicies";
import { Seo } from "../components/Seo";

export function LegalIndex() {
  return (
    <>
      <Seo
        title="Legal"
        description="Official DeskReplay legal policies and agreements, including pricing policy, privacy policy, terms of service, and related documents."
        canonicalPath="/legal"
      />
      <div className="bg-slate-950 min-h-screen pt-28 pb-20">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-12 h-12 rounded-xl bg-teal-500/15 flex items-center justify-center border border-teal-500/25">
            <Scale className="text-teal-400" size={22} />
          </div>
          <div>
            <p className="text-teal-400 text-xs uppercase tracking-widest font-semibold">Legal</p>
            <h1 className="text-slate-100 text-3xl font-extrabold tracking-tight">Policies & agreements</h1>
          </div>
        </div>
        <p className="text-on-dark-muted text-base leading-relaxed mb-10">
          Official legal documents for DeskReplay. Select a topic below. For contractual commitments, your executed order
          form or master agreement controls where it differs from these general policies.
        </p>
        <ul className="flex flex-col gap-2">
          {LEGAL_POLICY_ORDER.map(({ slug, label }) => (
            <li key={slug}>
              <Link
                to={`/legal/${slug}`}
                className="group flex items-center justify-between gap-4 rounded-xl border border-slate-800 bg-slate-900/40 hover:border-teal-500/30 hover:bg-teal-500/5 px-5 py-4 transition-all"
              >
                <span className="text-slate-200 group-hover:text-teal-300 font-medium">{label}</span>
                <ChevronRight
                  size={18}
                  className="text-on-dark-dim group-hover:text-teal-400 shrink-0 transition-colors"
                />
              </Link>
            </li>
          ))}
        </ul>
        </div>
      </div>
    </>
  );
}
